import styled from 'styled-components'

export const IntegrationContainer = styled.div`
  overflow: hidden;

  section {
    position: relative;
  }

  p {
    font-size: 18px;
    color: var(--grey2);
  }

  #banner_intro {
    h1 {
      font-size: 50px;
    }
  }

  @media only screen and (max-width: 1700px) {
    #banner_intro {
      background-position: 105%;
    }
  }

  @media only screen and (max-width: 1600px) {
    #banner_intro {
      background-position: 115%;
    }
  }

  @media only screen and (max-width: 1500px) {
    #banner_intro {
      background-size: 50%;
    }
  }

  @media only screen and (max-width: 1100px) {
    #banner_intro {
      background-position: 160%;
      background-size: 65%;
    }
  }
`

export const API = styled.section`
  padding: 5rem var(--paddingD) 0;

  .title {
    color: var(--grey8);
    font-weight: 700;
  }

  &.desktop {
    & .title {
      font-size: 40px;
    }

    & div {
      &.img-container,
      &.text-container {
        width: 50%;
      }

      &.text-container > *:not(:last-child) {
        margin-bottom: 3rem;
      }
    }
  }

  &.mobile {
    text-align: center;

    & .title {
      font-size: 28px;
      margin-bottom: 3rem;
    }

    div {
      &.text-container {
        margin-bottom: 5rem;
      }

      &.img-container {
        width: 80%;

        & > img {
          width: 100%;
        }
      }
    }
  }

  @media only screen and (max-width: 1050px) {
    &.desktop {
      div {
        &.img-container {
          width: 45%;

          & > img {
            width: 100%;
          }
        }

        &.text-container {
          padding-bottom: 3rem;
        }
      }
    }
  }
`

export const Institutions = styled.section`
  background: var(--blue6);
  color: var(--light);
  text-align: center;

  .title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 6rem;
  }

  p {
    color: var(--light);
    font-weight: 500;
    text-transform: uppercase;
  }

  div {
    &.item-container {
      position: relative;

      &::after {
        content: '';
        border-top: 3px solid rgba(94, 72, 232, 0.2);
        position: absolute;
        top: 40px;
        transform: translateY(-50%);
      }
    }

    &.icon-container {
      margin-bottom: 2.5rem;
      background: rgba(94, 72, 232, 0.1);
      border-radius: 10px;
      width: 80px;
      height: 80px;
      transform: rotate(45deg);

      & > span {
        transform: rotate(-45deg);
      }

      & > img {
        transform: rotate(-45deg) translate(-25%, 25%);
      }
    }
  }

  &.desktop {
    padding: 6rem 0;

    & path,
    & ellipse {
      vector-effect: non-scaling-stroke;
      stroke: rgba(94, 72, 232, 0.2);
      stroke-width: 3;
    }

    & path {
      fill: none;
    }

    & ellipse {
      fill: var(--blue8);
    }

    div {
      &.item-container {
        width: 50%;

        &::after {
          width: 86%;
          left: 8%;
        }
      }

      &.svg-container {
        position: absolute;

        &.left {
          left: 0;
          bottom: calc(6rem + 21px + 2.5rem + 38px);
          width: 29%;
          height: 165%;
        }

        &.right {
          right: 0;
          top: calc(6rem + 39px + 6rem + 38px);
          width: 27%;
          height: 177%;
        }
      }
    }
  }

  &.mobile {
    padding: 6rem var(--paddingD) 8rem;

    div {
      &.item-container {
        &:not(:last-child) {
          margin-bottom: 6rem;
        }

        &:last-child {
          padding: 0 1.5rem;
        }

        &::after {
          width: 76%;
          left: 12%;
        }
      }
    }
  }

  @media only screen and (max-width: 1700px) {
    &.desktop {
      & div.right {
        height: 166% !important;
      }
    }
  }

  @media only screen and (max-width: 1500px) {
    &.desktop {
      & div.right {
        height: 155% !important;
      }
    }
  }

  @media only screen and (max-width: 1400px) {
    &.desktop {
      & div.left {
        width: 30% !important;
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    &.desktop {
      & div.item-container {
        width: 70%;
      }

      & div.left {
        width: 22% !important;
        height: 180% !important;
      }

      & div.right {
        width: 22% !important;
        height: 175% !important;
      }
    }
  }

  @media only screen and (max-width: 500px) {
    &.mobile {
      div.item-container::after {
        width: 62%;
        left: 20%;
      }
    }
  }

  @media only screen and (max-width: 350px) {
    &.mobile {
      div.item-container::after {
        width: 60%;
      }

      p {
        font-size: 14px;
      }
    }
  }
`

export const WhiteLabel = styled.section`
  .title {
    color: var(--grey8);
    font-weight: 700;
    margin-bottom: 5rem;
  }

  p {
    color: var(--grey10);
  }

  &.desktop {
    padding: 8rem 0 8rem var(--paddingD);

    & .title {
      font-size: 60px;
    }

    & div {
      &.text-container {
        width: 65%;
      }

      &.img-container {
        position: relative;
        width: 35%;
        justify-content: flex-end;

        & > img {
          transform: translateX(25%);
        }
      }
    }
  }

  &.mobile {
    padding: 8rem var(--paddingD);
    text-align: center;

    & .title {
      font-size: 32px;
    }

    & div {
      &.text-container {
        margin-bottom: 10rem;
      }

      &.img-container > img {
        width: 100%;
      }
    }
  }

  @media only screen and (max-width: 1500px) {
    &.desktop {
      & div.text-container {
        width: 60%;
      }
    }
  }

  @media only screen and (max-width: 1300px) {
    &.desktop {
      & div.img-container > img {
        width: 160%;
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    &.desktop {
      & div.text-container {
        width: 50%;
      }
    }
  }
`
